module.exports = __webpack_public_path__ + "static/media/audio-file.2d6d10db.svg";